
    import { Options, Vue } from "vue-class-component";
    import { namespace } from "vuex-class";
    import $ from "jquery";
    import CardRh from "@/components/cards/ManzaCard.vue";
    import AlocacaoService from "@/service/v10/sigap/AlocacaoService";
    import SiteUtils from "@/assets/ts/aplicacao/site";
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import Multiselect from "@vueform/multiselect";
    import Cadastro from "./_Cadastro.vue";

    const authStore = namespace("auth");

    @Options({
        name: "OpcaoIndex",
        components: { CardRh, KDataTable, Multiselect, Cadastro },
    })
    export default class OpcaoIndex extends Vue {
        @authStore.Getter
        public perfis!: any;

        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = null;
        public opcao_id: any = null;
        public matriculaId: any = null;
        public opcoes: any = null;
        public modal_cadastro_locacao_alocacao = "modal_turma_locacao_alocacao";

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === "Enter" || e.keyCode === 13) {
                this.refreshTable();
            }
        }

        public limparFiltros() {
            this.opcao_id = null;
            this.refreshTable();
        }

        get opcoes_select() {
            if (this.opcoes) {
                return this.opcoes.map((item) => {
                    return { value: item.id, label: item.nome };
                });
            }
            return [];
        }

        public getOpcao() {
            this.processando = true;
            this.service.getOpcao()
                .then(response => {
                    this.opcoes = JSON.parse(JSON.stringify(response));
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }

        created() {
            this.matriculaId = this.$route.params.id;
            this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
            this.service = new AlocacaoService();
            this.getOpcao();
            this.config.ajax = {
                url: this.service.getApiUrl(),
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        opcao: this.opcao_id,
                        matriculaId: this.matriculaId,
                        search: d.search.value,
                    };
                    return dados;
                }
            };

            this.config.columns = [
                { data: "id", name: "id" },
                { data: "unidade.descricao", name: "unidade.descricao" },
                { data: "opcao", name: "opcao", class: "desktop" },
                { data: "id", name: "id", class: "desktop" },
            ];

            this.config.columnDefs = [
                {
                    targets: 2,
                    render: (row) => {
                        return row.nome.replaceAll("_", " ");
                    }
                },
                {
                    targets: 3,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + buttom + ' title="Excluir"><i class="fa fa-trash"></i></button>';
                        return texto;
                    },
                }
            ];
        }

        public tableatualizada() {
            $("[btn-excluir]").click((btn) => {
                const id = $(btn.currentTarget).data("id");
                this.excluirModelo(id);
            });
        }

        protected excluirModelo(id) {
            SiteUtils.alertConfimacao("Confirma a Exclusao", "",
                () => {
                    this.processando = true;
                    setTimeout(() => {
                        this.service.excluir(id)
                            .then(() => {
                                this.reloadDatatable = !this.reloadDatatable;
                                SiteUtils.toastSucesso("Exclusao realizada com sucesso!!");
                                this.processando = false;
                            })
                            .catch(error => {
                                this.processando = false;
                                SiteUtils.toastErro("Nao foi possivel Excluir", error.data.message);
                            });
                    }, 10);
                }
            );
        }
    }
